module.exports = __webpack_public_path__ + "static/media/VerLibroLogo.c34d28bd.svg";